import { useUnifiedAuth } from 'components/Common/UnifiedAuthContext';
import Spinner from 'components/Common/Spinner';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from 'types/NavTreeModel';
import { CacheKeys } from 'utils/constants';
import { landing, adminPortal } from 'utils/spaUrls';

export default function LandingPad() {
  const response = useUnifiedAuth();
  const isChiefAdmin = response.user?.['headlamp/roles']?.includes(UserRole.CHIEF_ADMIN);

  if (response.user) {
    localStorage.setItem(CacheKeys.userId, response.user.sub as string);
    localStorage.setItem(CacheKeys.orgId, response.user.org_id as string);
  }

  if (response.isLoading) {
    return <Spinner />;
  }
  else {
    return <Navigate to={isChiefAdmin ? adminPortal : landing} />;
  }
}
